var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-breadcrumb",
        { attrs: { crumbs: _vm.path } },
        [
          _c("w-input", {
            attrs: { placeholder: _vm.$ct("layout-name-label") },
            model: {
              value: _vm.layout.Name,
              callback: function ($$v) {
                _vm.$set(_vm.layout, "Name", $$v)
              },
              expression: "layout.Name",
            },
          }),
          _c("w-spacer"),
          _c(
            "div",
            { staticClass: "v-center" },
            [
              _c(
                "w-button-bar",
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.zoomOut()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "search-minus" } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.zoomLevelIndex = 3
                        },
                      },
                    },
                    [_vm._v(" [" + _vm._s(_vm.zoomLevel) + "%] ")]
                  ),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.zoomIn()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "search-plus" } })],
                    1
                  ),
                  _c("w-button", { on: { click: _vm.save } }, [
                    _vm._v(" " + _vm._s(_vm.$t("common.save")) + " "),
                  ]),
                  _c(
                    "w-dropdown",
                    {
                      attrs: { items: _vm.buttonBarItmes, right: "" },
                      on: {
                        click: function ($event) {
                          return _vm.triggerDropdown($event)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "bars" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-container",
        { staticClass: "container", attrs: { "no-padding": "" } },
        [
          _c(
            "w-row",
            {
              style: {
                flexGrow: 1,
                position: "relative",
                zIndex: 1,
                flexShrink: 1,
                minHeight: 0,
                overflow: "hidden",
              },
              attrs: { "no-margin": "" },
            },
            [
              _c(
                "app-page-container",
                [
                  _c("app-page", {
                    attrs: {
                      "show-grid": _vm.showGrid,
                      layout: _vm.saleLayout,
                      "zoom-level": _vm.zoomLevel,
                      lang: _vm.selectedLang,
                      "contact-group-id": _vm.layout.ContactGroupID,
                      "example-document": _vm.exampleDocument,
                    },
                  }),
                  _vm.showRequirementsPage
                    ? _c("app-requirements-page", {
                        attrs: {
                          "show-grid": _vm.showGrid,
                          layout: _vm.saleLayout,
                          "zoom-level": _vm.zoomLevel,
                          lang: _vm.selectedLang,
                          "contact-group-id": _vm.layout.ContactGroupID,
                          "example-document": _vm.exampleDocument,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("app-tab", {
                attrs: {
                  "full-control": _vm.fullControl,
                  tab: _vm.tab,
                  layout: _vm.layout.Data,
                  "contact-group-id": _vm.layout.ContactGroupID,
                },
                on: {
                  "update:tab": function ($event) {
                    _vm.tab = $event
                  },
                },
              }),
              _c("app-tabs", {
                on: { save: _vm.save },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.langModalOpen,
                callback: function ($$v) {
                  _vm.langModalOpen = $$v
                },
                expression: "langModalOpen",
              },
            },
            [
              _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("change-display-language"))),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c("app-custom-language-select", {
                        model: {
                          value: _vm.selectedLang,
                          callback: function ($$v) {
                            _vm.selectedLang = $$v
                          },
                          expression: "selectedLang",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c("w-button", { on: { click: _vm.closeLangModal } }, [
                        _vm._v(" " + _vm._s(_vm.$ct("common.close")) + " "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.editorSettingsModalOpen,
                callback: function ($$v) {
                  _vm.editorSettingsModalOpen = $$v
                },
                expression: "editorSettingsModalOpen",
              },
            },
            [
              _vm.editorSettingsModalOpen
                ? _c("app-editor-settings-edit", {
                    attrs: { layout: _vm.layout },
                    on: {
                      close: function ($event) {
                        _vm.editorSettingsModalOpen = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.missingModule,
            callback: function ($$v) {
              _vm.missingModule = $$v
            },
            expression: "missingModule",
          },
        },
        [
          _c("app-missing-module-modal", {
            attrs: { "module-id": 13 },
            on: {
              close: function ($event) {
                _vm.missingModule = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.historyModalOpen,
            callback: function ($$v) {
              _vm.historyModalOpen = $$v
            },
            expression: "historyModalOpen",
          },
        },
        [
          _vm.historyModalOpen
            ? _c("app-layout-history-modal", {
                attrs: { layout: _vm.layout },
                on: {
                  close: function ($event) {
                    _vm.historyModalOpen = false
                  },
                  layout: function ($event) {
                    return _vm.onInput($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.uploadTemplateModalOpen,
            callback: function ($$v) {
              _vm.uploadTemplateModalOpen = $$v
            },
            expression: "uploadTemplateModalOpen",
          },
        },
        [
          _vm.uploadTemplateModalOpen
            ? _c("app-upload-template-modal", {
                on: {
                  close: function ($event) {
                    _vm.uploadTemplateModalOpen = false
                  },
                  layout: function ($event) {
                    return _vm.onInput($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }